import styled from "styled-components";
import { CARD_STYLED_PROPS } from "./interface";
import { colors } from "../../../lib/colors";
import { initCardApear, cardClick } from "../../../animations/Interactions";

export const CardContainer = styled.div<CARD_STYLED_PROPS>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 36px 0 40px;
`;

export const ApearableCard = styled.div<CARD_STYLED_PROPS>`
  opacity: ${({ cleared, initialCardAnim }) =>
    !cleared && initialCardAnim ? 0 : 1};
  transform: ${({ cleared, initialCardAnim }) =>
    !cleared && initialCardAnim ? "translateY(86px)" : "transformY(0px)"};
  ${({ cleared, initialCardAnim }) =>
    !cleared && initialCardAnim && initCardApear}
  animation-delay: ${({ childNumber, cleared, initialCardAnim }) =>
    !cleared && initialCardAnim ? `${childNumber * 0.167}s` : "0s"};
`;

export const RotatableCard = styled.div<CARD_STYLED_PROPS>`
  background-color: transparent;
  width: 58px;
  height: 86px;
  perspective: 1000px;
  .rotatable {
    ${({ rotateCard }) => rotateCard && "transform: rotateY(180deg)"};
    transition: transform ${({ cleared }) => (cleared ? "0ms" : "250ms")};
    transition-timing-function: cubic-bezier(0.41, 0.21, 0.17, 0.79);
    transition-delay: ${({ childNumber, cleared, rotateCard }) =>
      cleared && !rotateCard ? "0s" : childNumber * 0.167}s;
  }
`;

export const CardWrapper = styled.div<CARD_STYLED_PROPS>`
  h3 {
    font-size: 12px;
    text-transform: uppercase;
    position: absolute;
    bottom: -30px;
    width: 100%;
    text-align: center;
    color: ${colors.secondaryBackground};
    opacity: 0;
    transform: translateY(19px);
    transition: all 450ms;
    transition-timing-function: cubic-bezier(0.17, 0.17, 0, 1);
  }
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.25s;
  transform-style: preserve-3d;
  .back,
  .front {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden; /* Safari */
    backface-visibility: hidden;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.4);
    border-radius: 9px;
  }

  &&.card {
    ${({ holdAnim }) => holdAnim && cardClick};
    transition: transform 250ms;
    transition-timing-function: cubic-bezier(0.41, 0.21, 0.17, 0.79);
    transition-delay: ${({ childNumber }) => childNumber * 0.167}s;
  }

  &&.hold {
    h3 {
      opacity: 1;
      transform: translateY(0px);
      transition: all 450ms;
      transition-timing-function: cubic-bezier(0.17, 0.17, 0, 1);
      letter-spacing: 0.42px;
    }
  }
`;
export const Cardback = styled.div`
  background-color: ${colors.customColor};
  transform: rotateY(180deg);
  z-index: 2;
`;

export const CardFront = styled.div<CARD_STYLED_PROPS>`
  background-color: ${({ winColor, showContent }) =>
    winColor && showContent ? colors.secondary : colors.customColor};
  ${({ holdAnim }) => holdAnim && cardClick};
  padding-top: 12px;
  line-height: 1;
  transition: background-color ${({ cleared }) => (cleared ? "0s" : "250ms")};
  transition-timing-function: cubic-bezier(0.17, 0, 0, 1);
  ${({ isClickable }) => isClickable && "cursor: pointer;"}
  p {
    font-size: 31px;
    color: ${({ suitColor }) => suitColor};
  }
  svg {
    height: 26px;
    width: 28px;
    position: absolute;
    right: 50%;
    transform: translateX(50%);
    bottom: 12px;
    path {
      fill: ${({ suitColor }) => suitColor};
    }
  }
`;
